import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { IframeModel, SetVideo } from 'src/app/shared/models/node';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sample-media-video',
  templateUrl: './sample-media-video.component.html',
  styleUrls: ['./sample-media-video.component.scss']
})
export class SampleMediaVideoComponent implements OnInit {
  @Input() block: SetVideo = {} as SetVideo;
  @Input() column: string = '';
  @Input() codice_iframe: string = '';
  public classItem: string = '';
  public objIframe: IframeModel = {} as IframeModel;
  public domainWebsite = environment.urlApi;
  public imgPath = "";
  public showThumbnail = true;
  public onHoverVideo: boolean = false;
  public showOverlay: boolean = true;
  @ViewChild('iframeVideo') iframeVideo?: ElementRef;

  constructor(private helperService: HelpersService) { }

  ngOnInit(): void {
    this.getIframeAtribute();
    this.setColumnItem();
  }

  private getIframeAtribute() {
    let iframe;
    if (this.block && this.block.link_video !== undefined) {
      iframe = this.helperService.retrieveIframe(this.block.link_video).children[0];
    } else {
      iframe = this.helperService.retrieveIframe(this.codice_iframe).children[0];
      this.showThumbnail = false;
    }
    this.objIframe = {
      src: iframe.attribs['src'],
      width: iframe.attribs['width'],
      height: iframe.attribs['height']
    }
    if (this.block.cover_video) {
      this.imgPath = this.domainWebsite + this.helperService.retrieveImage(this.block.cover_video, "src");
    } else {
      this.showThumbnail = false;
    }
  }

  private setColumnItem() {
    if (this.column === '4') {
      this.classItem = 'col-9 m-auto';
    } else {
      this.classItem = 'col-12';
    }
  }

  public onOverlayClick() {
    this.showOverlay = false;
  }

}
